import React, { useState, useEffect, useMemo, useRef } from "react"
import { Container, Row, Col } from "react-bootstrap"
import DataTable from "react-data-table-component"
import CompanySelector from "ATSComponents/Common/CompanySelector"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
import axios from "axios"
import Select from "react-select";
import { components } from "react-select";
import Swal from "sweetalert2";
import moment from "moment-timezone";
import { FaCalendarAlt, FaCheckCircle, FaPhoneAlt, FaPhoneSlash, FaRedo } from "react-icons/fa";
const getTodayDate = () => {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, "0")
  const day = String(today.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

const EmptyCallLogsState = () => (
  <div
    style={{
      width: "100%",
      minHeight: 170,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "28px 20px",
      background: "linear-gradient(180deg, #fbfdff 0%, #f4f9fe 100%)",
      textAlign: "center",
    }}
  >
    <div style={{ maxWidth: 360 }}>
      <div
        aria-hidden="true"
        style={{
          width: 52,
          height: 52,
          margin: "0 auto 12px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          background: "#eaf4ff",
          border: "1px solid #cfe3f7",
          color: "#1a5fa8",
          fontSize: 21,
        }}
      >
        <FaPhoneAlt />
      </div>
      <div style={{ color: "#18324d", fontSize: 16, fontWeight: 700, lineHeight: 1.3 }}>
        No call records yet
      </div>
      <div style={{ marginTop: 6, color: "#6b7f93", fontSize: 12.5, lineHeight: 1.5 }}>
        Try changing the filters or choose another company to view extension call activity.
      </div>
    </div>
  </div>
)

const customStyles = {
  headRow: {
    style: {
      backgroundColor: "#eaf4ff",
      borderTop: "1px solid #d8e6f3",
      borderBottom: "1px solid #c4d8ea",
      minHeight: "42px",
    },
  },
  headCells: {
    style: {
      color: "#0b3a5d",
      fontSize: "11px",
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.03em",
      paddingLeft: "16px",
      paddingRight: "16px",
      overflow: "visible",
      whiteSpace: "normal",
    },
  },
  rows: {
    style: {
      minHeight: "48px",
      borderBottom: "1px solid #e7edf3",
    },
    stripedStyle: {
      backgroundColor: "#f9fbfd",
    },
  },
  cells: {
    style: {
      color: "#1f2f46",
      fontSize: "12px",
      paddingLeft: "16px",
      paddingRight: "16px",
    },
  },
  pagination: {
    style: {
      borderTop: "1px solid #e7edf3",
      minHeight: "48px",
    },
  },
}

const reportCardStyle = {
  background: "#fff",
  border: "1px solid #d9e4ef",
  borderRadius: 10,
  boxShadow: "0 8px 24px rgba(15, 23, 42, 0.07)",
}

const selectStyles = {
  control: base => ({
    ...base,
    minHeight: 38,
    borderColor: "#d9e4ef",
    boxShadow: "none",
    fontSize: 13,
    "&:hover": { borderColor: "#0f766e" },
  }),
  valueContainer: base => ({ ...base, padding: "2px 10px" }),
  indicatorSeparator: base => ({ ...base, backgroundColor: "#d9e4ef" }),
  option: (base, state) => ({
    ...base,
    fontSize: 13,
    backgroundColor: state.isSelected ? "#12395c" : state.isFocused ? "#e6f5f3" : "#fff",
    color: state.isSelected ? "#fff" : "#1f2f46",
  }),
}
const PAGE_SIZE = 10;

const ellipsisCell = value => (
  <span
    title={value || "-"}
    style={{
      display: "block",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      textAlign: "left",
    }}
  >
    {value || "-"}
  </span>
)

const getInitials = value =>
  String(value || "")
    .trim()
    .split(/\s+/)
    .map(part => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase() || "?"

const getAvatarStyle = value => {
  const palette = [
    { bg: "#fff7ed", border: "#f59e0b", color: "#c2410c" },
    { bg: "#eff6ff", border: "#38bdf8", color: "#0369a1" },
    { bg: "#ecfeff", border: "#22d3ee", color: "#0e7490" },
    { bg: "#fdf2f8", border: "#f472b6", color: "#be185d" },
    { bg: "#f5f3ff", border: "#a78bfa", color: "#6d28d9" },
  ]
  let hash = 0
  String(value || "").split("").forEach(char => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash)
  })
  return palette[Math.abs(hash) % palette.length]
}

const statusBadge = value => {
  const label = formatStatusLabel(value)
  const isAnswered = String(value || "").toLowerCase() === "answered"
  const isNoAnswer = String(value || "").toLowerCase() === "no answer"
  const color = isAnswered ? "#047857" : isNoAnswer ? "#b91c1c" : "#475569"
  const bg = isAnswered ? "#e8f7ef" : isNoAnswer ? "#fdecec" : "#f1f5f9"
  const border = isAnswered ? "#b7e5ca" : isNoAnswer ? "#fac7c7" : "#d9e2ec"

  return (
    <span
      title={label}
      style={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: 999,
        padding: "3px 9px",
        background: bg,
        color,
        border: `1px solid ${border}`,
        fontWeight: 700,
        whiteSpace: "nowrap",
        fontSize: 11,
      }}
    >
      {label}
    </span>
  )
}
const audioCache = {};

const formatDateTime = (dateStr) => {
  if (!dateStr) return "-";

  const date = moment.parseZone(String(dateStr));

  return date.isValid()
    ? date.format("DD-MM-YYYY h:mm:ss A")
    : "-";
};

const formatStatusLabel = value => {
  if (!value) return "-"
  const text = String(value).trim()
  return text.charAt(0).toUpperCase() + text.slice(1)
}

const CustomLoader = () => (
  <OrgTableShimmer columns={6} rows={6} titleWidth="220px" />
)

const paginationComponentOptions = {
  selectAllRowsItemText: 'All',
  selectAllRowsItem: true,
}
const RecordingPlayer = ({ recordingUrl, callLogId, disposition, currentPlayingRef }) => {
  const cacheKey = String(callLogId || "");
  const isAnswered = String(disposition || "").trim().toLowerCase() === "answered";
  const [audioSrc, setAudioSrc] = useState(audioCache[cacheKey] || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const audioRef = useRef(null);

  useEffect(() => {
    setAudioSrc(audioCache[cacheKey] || null);
    setError(null);
    setLoading(false);
  }, [cacheKey, recordingUrl]);

  useEffect(() => () => {
    const cachedUrl = audioCache[cacheKey];
    if (cachedUrl) {
      URL.revokeObjectURL(cachedUrl);
      delete audioCache[cacheKey];
    }
  }, [cacheKey]);

  const loadRecording = async (forceReload = false) => {
    if (!recordingUrl || !callLogId || loading) return;
    if (forceReload && audioCache[cacheKey]) {
      URL.revokeObjectURL(audioCache[cacheKey]);
      delete audioCache[cacheKey];
      setAudioSrc(null);
    }
    if (audioCache[cacheKey]) {
      setAudioSrc(audioCache[cacheKey]);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `/api/v1/play-recording/?call_log_id=${callLogId}`,
        { responseType: "blob" }
      );
      if (!response.data || response.data.size === 0) {
        throw new Error("Empty recording response");
      }

      const audioBlob = new Blob([response.data], {
        type: "audio/mpeg",
      });
      if (audioBlob.size === 0) {
        throw new Error("Empty audio blob");
      }

      const audioUrl = URL.createObjectURL(audioBlob);
      audioCache[cacheKey] = audioUrl;
      setAudioSrc(audioUrl);
    } catch (requestError) {
      console.error("Audio fetch failed:", requestError);
      setError(requestError?.response?.status === 404 ? "not-found" : "retry");
    } finally {
      setLoading(false);
    }
  };

  const handlePlay = () => {
    if (currentPlayingRef.current && currentPlayingRef.current !== audioRef.current) {
      currentPlayingRef.current.pause();
    }
    currentPlayingRef.current = audioRef.current;
  };

  if (!isAnswered) {
    return (
      <div
        style={{
          width: "100%",
          minHeight: 32,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "6px 10px",
          border: "1px solid #e2e8f0",
          borderRadius: 6,
          background: "#f8fafc",
          color: "#64748b",
          fontSize: 11,
          fontWeight: 600,
          textAlign: "center",
        }}
      >
        Recording unavailable for unanswered calls
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          width: "100%",
          color: "#9f1239",
          background: "#fff1f2",
          border: "1px solid #fecdd3",
          borderRadius: 999,
          fontSize: "11px",
          textAlign: "center",
          fontWeight: 700,
          padding: "5px 9px",
        }}
      >
        <div>{error === "not-found" ? "Record Not Found" : "Unable to play recording"}</div>
        {error === "retry" && (
          <button
            type="button"
            onClick={() => loadRecording(true)}
            style={{ marginTop: 4, border: 0, background: "transparent", color: "#9f1239", textDecoration: "underline", fontWeight: 700 }}
          >
            Retry
          </button>
        )}
      </div>
    );
  }

  return (
    <div style={{ width: "100%", minWidth: 0 }}>
      {!audioSrc && (
        <button
          type="button"
          disabled={!recordingUrl || !callLogId || loading}
          onClick={() => loadRecording()}
          style={{ width: "100%", minHeight: 32, border: "1px solid #cbd5e1", borderRadius: 6, background: recordingUrl ? "#eff6ff" : "#f1f5f9", color: recordingUrl ? "#145b84" : "#64748b", fontSize: 12, fontWeight: 700, cursor: recordingUrl ? "pointer" : "not-allowed" }}
        >
          {loading ? "Loading..." : "Play"}
        </button>
      )}

      {!recordingUrl && <div style={{ marginTop: 4, color: "#9f1239", fontSize: 11, textAlign: "center", fontWeight: 700 }}>Record Not Found</div>}

      {audioSrc && (
        <audio
          ref={audioRef}
          controls
          preload="metadata"
          onPlay={handlePlay}
          onError={() => setError("retry")}
          style={{ width: "100%", minWidth: 190, height: 34, display: loading ? "none" : "block" }}
          src={audioSrc}
        />
      )}
    </div>
  );
};

function ExtensionLogs() {
  document.title = "ATS - Extension Logs";
  const [companyId, setCompanyId] = useState(null)
  const [logs, setLogs] = useState([])
  const [page, setPage] = useState(1)
  const [paginationResetKey, setPaginationResetKey] = useState(0)
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [loading, setLoading] = useState(false)
  const [startDate, setStartDate] = useState(getTodayDate())
  const [endDate, setEndDate] = useState(getTodayDate())
  const [extensionName, setExtensionName] = useState("")
  const [candidateName, setCandidateName] = useState("")
  const [debouncedCandidateName, setDebouncedCandidateName] = useState("")
  const [contacts, setContacts] = useState([]);
  const [loadingContacts, setLoadingContacts] = useState(false);
  const [selectedRecruiters, setSelectedRecruiters] = useState([]);
  const [jobOptions, setJobOptions] = useState([]);
  const [loadingJobs, setLoadingJobs] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [jobPage, setJobPage] = useState(1);
  const [jobTotalPages, setJobTotalPages] = useState(1);
  const [jobSearch, setJobSearch] = useState("");
  const [callStatus, setCallStatus] = useState({
  value: "ANSWERED",
  label: "ANSWERED",
});
const callStatusOptions = [
  { value: "ANSWERED", label: "ANSWERED" },
  { value: "NO ANSWER", label: "NO ANSWER" },
  { value: "initiated", label: "Initiated" },
  { value: "all", label: "All" },
];
const fetchContacts = async () => {
  if (!companyId) return;

  setLoadingContacts(true);

  try {
    const response = await axios.get(
      "/api/v1/company-recruiters/",
      // {
      //   // params: { company_id: companyId },
      // }
    );

    const list = response.data?.data || [];

    const mapped = list.map(r => ({
      value: r.id,
      label: r.name,
      fullName: r.name,
      role: r.role
    }));

    setContacts(mapped);
    if (mapped.length === 1) {
      setSelectedRecruiters(mapped[0]);
    }
  } catch (error) {
    console.error("Recruiter API Error:", error);
    setContacts([]);
  } finally {
    setLoadingContacts(false);
  }
};

const fetchJobOptions = async (pageNumber = 1, search = jobSearch) => {
  if (!companyId) return;

  try {
    setLoadingJobs(true);
    const response = await axios.get("/api/v1/create-job-order/", {
      params: {
        company_id: companyId,
        page: pageNumber,
        size: PAGE_SIZE,
        ...(search ? { search } : {}),
      },
    });
    const list = response.data?.results || response.data?.data || response.data || [];
    const totalCount = response.data?.count || list.length;
    const mapped = list
      .map(job => ({
        value: job.job_id ?? job.id ?? job.job_order_id,
        label: job.job_title || job.title || `Job ${job.job_id ?? job.id}`,
      }))
      .filter(job => job.value);
    setJobOptions(mapped);
    setJobPage(pageNumber);
    setJobTotalPages(Math.max(1, Math.ceil(totalCount / PAGE_SIZE)));
  } catch (error) {
    console.error("Job order API Error:", error);
    setJobOptions([]);
    setJobTotalPages(1);
  } finally {
    setLoadingJobs(false);
  }
};
useEffect(() => {
  if (companyId) {
    fetchContacts();
    fetchJobOptions();
  }
}, [companyId]);


  const handleCompanyChange = c => {
    if (c?.company_id) {
      setCompanyId(c.company_id)
      setPage(1)
      setSelectedJob(null)
      setSelectedRecruiters(null)
      setJobSearch("")
      setJobPage(1)
    }
  }

  const jobMenuList = props => (
    <components.MenuList {...props}>
      {props.children}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
          padding: "8px 10px",
          borderTop: "1px solid #e2e8f0",
          background: "#fff",
          fontSize: 12,
        }}
      >
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          disabled={loadingJobs || jobPage <= 1}
          onMouseDown={event => {
            event.preventDefault()
            fetchJobOptions(jobPage - 1, jobSearch)
          }}
        >
          Prev
        </button>
        <span style={{ color: "#64748b" }}>Page {jobPage}/{jobTotalPages}</span>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          disabled={loadingJobs || jobPage >= jobTotalPages}
          onMouseDown={event => {
            event.preventDefault()
            fetchJobOptions(jobPage + 1, jobSearch)
          }}
        >
          Next
        </button>
      </div>
    </components.MenuList>
  )

  const handleStartDateChange = e => {
    const nextStartDate = e.target.value
    setStartDate(nextStartDate)

    if (endDate && nextStartDate && endDate < nextStartDate) {
      setEndDate("")
    }
  }

  const handleEndDateChange = e => {
    const nextEndDate = e.target.value

    if (startDate && nextEndDate && nextEndDate < startDate) {
      setEndDate("")
      return
    }

    setEndDate(nextEndDate)
  }

  const fetchCallLogs = async (pageNumber = 1, rows = perPage) => {
  if (!startDate || !endDate) {
    setLogs([])
    setTotalRows(0)
    setPage(1)
    return
  }

  try {
    setLoading(true);

    const recruiterId = selectedRecruiters?.value || "";
    const jobId = selectedJob?.value || "";

    const { data } = await axios.get("api/v1/extension-call-records/", {
      params: {
        startdate: startDate,
        enddate: endDate,
        page: pageNumber,
        size: rows,
        recruiter_id: recruiterId,
        job_id: jobId,
        call_status: callStatus?.value,
        company_id: companyId,
        ...(debouncedCandidateName.trim()
          ? { candidate_name: debouncedCandidateName.trim() }
          : {}),
      },
    });

    if (data?.data) {
      const results = data.data.results || [];

      setLogs(results);
      setTotalRows(data.data.count || 0);
      setPage(pageNumber);
    }
  } catch (error) {
    console.error("Error fetching call logs:", error);

    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch call logs. Please try again.",
    });
  } finally {
    setLoading(false);
  }
};
  const handlePageChange = page => {
    fetchCallLogs(page)
  }

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage)
    setPage(page)
    fetchCallLogs(page, newPerPage)
  }
  const currentPlayingRef = useRef(null);
  const displayedLogs = useMemo(
    () => logs.slice(0, perPage),
    [logs, perPage]
  )
  const callSummary = useMemo(() => {
    const answered = logs.filter(item => String(item.disposition || "").toLowerCase() === "answered").length
    const missed = logs.filter(item => String(item.disposition || "").toLowerCase() === "no answer").length
    const totalDuration = logs.reduce((sum, item) => sum + Number(item.billsec || 0), 0)
    const avgDuration = logs.length ? Math.round(totalDuration / logs.length) : 0

    return {
      total: totalRows,
      answered,
      missed,
      avgDuration,
    }
  }, [logs, totalRows])

  const summaryCards = [
    { label: "Total Calls", value: callSummary.total, icon: <FaPhoneAlt />, accent: "#2563eb", bg: "#eff6ff" },
    { label: "Answered", value: callSummary.answered, icon: <FaCheckCircle />, accent: "#059669", bg: "#ecfdf5" },
    { label: "No Answer", value: callSummary.missed, icon: <FaPhoneSlash />, accent: "#dc2626", bg: "#fef2f2" },
    { label: "Avg Duration", value: `${callSummary.avgDuration}s`, icon: <FaCalendarAlt />, accent: "#d97706", bg: "#fffbeb" },
  ]

  const columns = [
    {
      name: "Recruiter Name",
      selector: row => row.extname || "-",
      cell: row => {
        const avatar = getAvatarStyle(row.extname)
        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0, width: "100%", textAlign: "left" }}>
            <span
              style={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                background: avatar.bg,
                border: `1px solid ${avatar.border}`,
                color: avatar.color,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                fontSize: 11,
                fontWeight: 800,
              }}
              title={row.extname || "-"}
            >
              {getInitials(row.extname)}
            </span>
            <div style={{ minWidth: 0, flex: "1 1 auto" }}>
              <div style={{ fontWeight: 700, color: "#102a43" }}>{ellipsisCell(row.extname)}</div>
            </div>
          </div>
        )
      },
      sortable: true,
      minWidth: "150px",
      grow: 1.25,
    },
    {
      name: "Extension",
      selector: row => row.extension || "-",
      cell: row => (
        <span
          title={row.extension || "-"}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: 34,
            borderRadius: 999,
            padding: "3px 8px",
            background: "#eef6ff",
            color: "#125986",
            border: "1px solid #cfe5f8",
            fontWeight: 800,
            fontSize: 11,
          }}
        >
          {row.extension || "-"}
        </span>
      ),
      sortable: true,
      minWidth: "70px",
      grow: 0.4,
    },
    {
      name: "Job Title",
      selector: row => row.job_title || "-",
      cell: row => ellipsisCell(row.job_title),
      sortable: true,
      minWidth: "155px",
      grow: 1.45,
    },
    {
      name: "Candidate Name",
      selector: row => row.candidate_name || "-",
      cell: row => (
        <div style={{ minWidth: 0, width: "100%", textAlign: "left" }}>
          <div style={{ fontWeight: 700, color: "#102a43" }}>{ellipsisCell(row.candidate_name)}</div>
          <div style={{ fontSize: 12, color: "#64748b" }}>{ellipsisCell(row.dst)}</div>
        </div>
      ),
      sortable: true,
      minWidth: "170px",
      grow: 1.5,
    },
    {
      name: "Date / Time",
      selector: row => {
        const date = formatDateTime(row.calldate)
        return <span title={date}>{date}</span>
      },
      sortable: true,
      minWidth: "155px",
      grow: 1.1,
    },
    {
      name: "Status",
      selector: row => formatStatusLabel(row.disposition),
      cell: row => statusBadge(row.disposition),
      sortable: true,
      minWidth: "115px",
      grow: 0.85,
    },
    {
      name: "Type",
      selector: row => formatStatusLabel(row.callstatus),
      cell: row => ellipsisCell(formatStatusLabel(row.callstatus)),
      sortable: true,
      minWidth: "105px",
      grow: 0.75,
    },
    {
      name: "Duration",
      selector: row => (
        <span title={row.billsec || "-"} style={{ fontWeight: 700, fontSize: 11 }}>{row.billsec || "-"}</span>
      ),
      sortable: true,
      minWidth: "70px",
      grow: 0.4,
    },
    {
      name: "Recording",
      minWidth: "225px",
      grow: 1.45,
      cell: row => {
        return (
          <div style={{ width: "100%" }}>
            <RecordingPlayer
              recordingUrl={row.recording_url}
              callLogId={row.id}
              disposition={row.disposition}
              currentPlayingRef={currentPlayingRef}
            />
          </div>
        );
      }
    }
  ]

  useEffect(() => {
    if (!companyId) return
    setPage(1)
    setPaginationResetKey(value => value + 1)
    fetchCallLogs(1)
  }, [startDate, endDate, companyId, selectedRecruiters, selectedJob, callStatus, debouncedCandidateName])

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedCandidateName(candidateName)
      setPage(1)
    }, 400)
    return () => clearTimeout(timer)
  }, [candidateName])

  return (
    <div
      className="page-content allact-tabs extension-logs-modern-page"
      style={{
        background: "linear-gradient(180deg, #f3f7fb 0%, #eef4f8 48%, #f8fafc 100%)",
        minHeight: "100vh",
        paddingTop: 28,
      }}
    >
      <style>{`
        .ext-logs-table-scroll > div {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .ext-logs-table-scroll > div::-webkit-scrollbar {
          display: none;
          height: 0;
        }
      `}</style>
      <Container fluid>
        <div className="page-title-box actjobbread mb-0">
          <div
            style={{
              ...reportCardStyle,
              padding: "14px 18px",
              marginTop: 55,
              marginBottom: 12,
              overflow: "hidden",
              background: "linear-gradient(135deg, #ffffff 0%, #f0fdfa 100%)",
              borderLeft: "4px solid #0f766e",
              boxShadow: "0 8px 22px rgba(15, 23, 42, 0.07)",
            }}
          >
            <Row className="align-items-center g-3">
              <Col lg={7} md={7}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div
                    style={{
                      width: 38,
                      height: 38,
                      borderRadius: 9,
                      background: "linear-gradient(135deg, #145b84 0%, #0f766e 100%)",
                      color: "#ffffff",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      border: "1px solid rgba(255, 255, 255, 0.24)",
                    }}
                  >
                    <FaPhoneAlt />
                  </div>
                  <div>
                    <h1 style={{ margin: 0, fontSize: 21, color: "#102a43", fontWeight: 800, lineHeight: 1.2 }}>
                      Extension Logs
                    </h1>
                    <div style={{ color: "#64748b", fontSize: 12, marginTop: 2 }}>
                      Track recruiter calls, durations, call outcomes, and recordings.
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={5} md={5}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: 12,
                    width: "100%",
                  }}
                >
                  <label
                    className="form-label mb-0"
                    style={{ fontSize: 12, fontWeight: 800, color: "#0f3554", whiteSpace: "nowrap" }}
                  >
                    Select Company
                  </label>
                  <div style={{ width: 220, maxWidth: "100%" }}>
                    <CompanySelector
                      onCompanyChange={handleCompanyChange}
                      showAllOption
                      allOptionValue="all"
                      allOptionLabel="All"
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <Row className="g-3 mb-3">
            {summaryCards.map(card => (
              <Col xxl={3} lg={3} md={6} key={card.label}>
                <div
                  style={{
                    ...reportCardStyle,
                    padding: "14px 16px",
                    minHeight: 88,
                    position: "relative",
                    overflow: "hidden",
                    borderTop: `3px solid ${card.accent}`,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
                    <div>
                      <div style={{ fontSize: 12, color: "#64748b", fontWeight: 700, textTransform: "uppercase" }}>
                        {card.label}
                      </div>
                      <div style={{ marginTop: 6, color: "#102a43", fontSize: 24, fontWeight: 800 }}>
                        {card.value || 0}
                      </div>
                    </div>
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 10,
                        background: card.bg,
                        color: card.accent,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      {card.icon}
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <div style={{ ...reportCardStyle, padding: 16, marginBottom: 16, borderLeft: "4px solid #0f766e" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "minmax(190px, 1fr) minmax(190px, 1fr) minmax(190px, 1fr) minmax(150px, 0.75fr) minmax(150px, 0.75fr) minmax(160px, 0.8fr) minmax(120px, auto)",
                gap: 16,
                alignItems: "end",
                width: "100%",
              }}
            >
              <div>
                <label className="form-label mb-1" style={{ fontSize: 12, fontWeight: 800, color: "#475569" }}>
                  Recruiter
                </label>
                <Select
                  isLoading={loadingContacts}
                  options={contacts}
                  value={selectedRecruiters}
                  onChange={(val) => setSelectedRecruiters(val)}
                  placeholder="Select recruiter"
                  classNamePrefix="react-select"
                  styles={selectStyles}
                />
              </div>
              <div>
                <label className="form-label mb-1" style={{ fontSize: 12, fontWeight: 800, color: "#475569" }}>
                  Job Order
                </label>
                <Select
                  isLoading={loadingJobs}
                  options={jobOptions}
                  value={selectedJob}
                  onChange={(val) => setSelectedJob(val)}
                  onInputChange={(value, actionMeta) => {
                    if (actionMeta.action === "input-change" && value !== jobSearch) {
                      setJobSearch(value);
                      fetchJobOptions(1, value);
                    }
                    return value;
                  }}
                  placeholder="Select job order"
                  classNamePrefix="react-select"
                  styles={selectStyles}
                  components={{ MenuList: jobMenuList }}
                  isClearable
                />
              </div>
              <div>
                <label className="form-label mb-1" style={{ fontSize: 12, fontWeight: 800, color: "#475569" }}>
                  Candidate Name
                </label>
                <input
                  type="search"
                  className="form-control"
                  value={candidateName}
                  onChange={event => setCandidateName(event.target.value)}
                  placeholder="Search candidate"
                  style={{ fontSize: 13, height: 38 }}
                />
              </div>
              <div>
                <label className="form-label mb-1" style={{ fontSize: 12, fontWeight: 800, color: "#475569" }}>
                  Start Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={handleStartDateChange}
                  style={{ fontSize: 13, height: 38 }}
                />
              </div>
              <div>
                <label className="form-label mb-1" style={{ fontSize: 12, fontWeight: 800, color: "#475569" }}>
                  End Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={handleEndDateChange}
                  style={{ fontSize: 13, height: 38 }}
                />
              </div>
              <div>
                <label className="form-label mb-1" style={{ fontSize: 12, fontWeight: 800, color: "#475569" }}>
                  Call Status
                </label>
                <Select
                  options={callStatusOptions}
                  value={callStatus}
                  onChange={(val) => setCallStatus(val)}
                  placeholder="Select status"
                  classNamePrefix="react-select"
                  styles={selectStyles}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button
                  className="btn"
                  style={{
                    height: 38,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "7px 16px",
                    background: "linear-gradient(135deg, #12395c, #0f766e)",
                    color: "#fff",
                    border: "none",
                    borderRadius: 7,
                    fontWeight: 700,
                    boxShadow: "0 6px 14px rgba(15, 118, 110, 0.22)",
                  }}
                  onClick={() => {
                    const today = getTodayDate()
                    setStartDate(today)
                    setEndDate(today)
                    setExtensionName("");
                    setCandidateName("");
                    setSelectedRecruiters(null);
                    setSelectedJob(null);
                    setCallStatus({ value: "ANSWERED", label: "ANSWERED" });
                    setPage(1);
                    fetchCallLogs(1);
                  }}
                >
                  <FaRedo size={12} />
                  Clear Filters
                </button>
              </div>
            </div>
            {callStatus?.value === "initiated" && (
              <div
                style={{
                  marginTop: 12,
                  background: "#fff7ed",
                  border: "1px solid #fed7aa",
                  color: "#9a3412",
                  borderRadius: 8,
                  padding: "9px 12px",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                Calls are initiated. Recordings will be available after some time.
              </div>
            )}
          </div>

          <Row className="mt-0">
            <Col>
              <div style={{ ...reportCardStyle, overflow: "hidden" }} id="ExtensionLogs_Datatable">
                <div
                  style={{
                    padding: "12px 16px",
                    borderBottom: "1px solid #e5edf6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 12,
                    background: "#fff",
                  }}
                >
                  <div style={{ fontWeight: 800, color: "#102a43", fontSize: 15 }}>Call Records</div>
                  <div style={{ color: "#64748b", fontSize: 12 }}>
                    Showing {displayedLogs.length} of {totalRows} records
                  </div>
                </div>
                <div className="ext-logs-table-scroll" style={{ padding: 0 }} id="CallLogs">
                  <DataTable
                    columns={columns}
                    data={displayedLogs}
                    noDataComponent={<EmptyCallLogsState />}
                    pagination
                    paginationResetDefaultPage={paginationResetKey % 2 === 1}
                    customStyles={customStyles}
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={perPage}
                    paginationDefaultPage={page}
                    paginationRowsPerPageOptions={[10, 20, 50, 100]}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    highlightOnHover
                    striped
                    responsive
                    paginationComponentOptions={paginationComponentOptions}
                    persistTableHead
                    progressPending={loading}
                    progressComponent={<CustomLoader />}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  )
}
export default ExtensionLogs
